export const FileProcessingStatus = {
  UPLOAD_IN_PROGRESS: 'upload-in-progress' as const,
  UPLOAD_ERROR: 'upload-error' as const,
  PROCESSING_ERROR: 'processing-error' as const,
  PROCESSING: 'processing' as const,
  PROCESSED: 'processed' as const,
  PROCESSED_SPREADSHEET: 'processed-spreadsheet' as const,
  PROCESSED_IMAGE: 'processed-image' as const,
  FILE_SIZE_EXCEEDED: 'file-size-exceeded' as const,
};
